/** @format */

import { Component, OnDestroy } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { Company } from "src/app/models/company.model"
import { DataPoint } from "src/app/models/datapoint.model"
import { Plant } from "src/app/models/plant.model"
import { Unit } from "src/app/models/unit.model"
import { CompanyService } from "src/app/services/company/company.service"
import { DataPointService } from "src/app/services/data-point/data-point.service"
import { ErrorHandlerService } from "src/app/services/errorHandler/error-handler.service"
import { PlantService } from "src/app/services/plant/plant.service"
import { ToastService } from "src/app/services/toast/toast.service"
import { UnitService } from "src/app/services/unit/unit.service"
import { Roles } from "src/app/auth/roles";
import { RefreshStateService } from "src/app/services/refresh-state/refresh-state.service"

@Component({
	standalone: false,
	selector: "app-data-point",
	templateUrl: "./data-point.component.html",
	styleUrls: ["./data-point.component.css"],
})
export class DataPointComponent implements OnDestroy {
	readonly Roles = Roles;
	activeItem = 0
	assignedPlants: any = []
	companies: Company[] = []
	currentRole: any = ""
	dataPoints: DataPoint[] = []
	firstRender: boolean = false
	plants: Plant[] = []
	resetPlant = false
	resetUnit = false
	selectedDp: any = "";
	showDeactivateMenu= false
	showMenu = false
	successAddText = "Form Field successfully added!"
	successUpdateText = "Form Field successfully updated!"
	units: Unit[] = []

	//pagination data
	currentPage: number = 1
	data: Plant[] = []
	pageSize: number = 7
	totalPages: number = 1
	loopArray: number[] = []

	errorMessage = {
		success: true,
		message: ''
	}

	deactivateText = {
		title: "Deactivate Form Field",
		message1: "",
		message2: "This action is irreversible. Do you wish to proceed?"
	}
	
	emptyStateDataPoints = {
		imgPath: "../../assets/datapoint.svg",
		message1: "No form fields to display",
		message2: "Created form fields will appear here.",
	}

	emptyStateCompanies = {
		imgPath: "../../assets/datapoint.svg",
		message1: "Select an account holder to see associated form fields listed here",
		message2: "",
	}

	emptyStatePlants = {
		imgPath: "../../assets/datapoint.svg",
		message1: "Select a client to see associated form fields listed here",
		message2: "",
	}

	emptyStateUnits = {
		imgPath: "../../assets/datapoint.svg",
		message1: "Select a branch to see associated form fields listed here",
		message2: "",
	}

	get values() {
		return {
			data: this.data,
			currentPage: this.currentPage, 
			totalPages: this.totalPages, 
			loadData: this.loadData, 
			loopArray: this.loopArray 
		}
	}

	plantDetails: Plant = {
		plantId: 0,
		plantName: "",
		isDeleted: false,
	}

	selectedValues = {
		company: {
			companyId: 0,
			companyName: "",
			isDeleted: false
		},
		plant: {
			plantId: 0,
			plantName: "",
			isDeleted: false
		},
		unit: {
			unitId: 0,
			unitName: "",
			isDeleted: false
		},
	}
	
	constructor(
		private route: ActivatedRoute,
		private plantService: PlantService,
		private companyService: CompanyService,
		private dataPointService: DataPointService,
		private unitService : UnitService,
		private router: Router,
		public toastService: ToastService,
		private errorService: ErrorHandlerService,
		private refreshState: RefreshStateService,
	) {}

	activateAddDataPointBtn() {
		if (this.currentRole === Roles.superAdmin) {
			if (
				this.selectedValues.company.companyId === 0 ||
				this.selectedValues.plant.plantId === 0 ||
				this.selectedValues.unit.unitId === 0
			) {
				return false
			} else if (
				this.selectedValues.company.isDeleted ||
				this.selectedValues.plant.isDeleted ||
				this.selectedValues.unit.isDeleted
			) {
				return false
			} else {
				return true
			}
		} else if (this.currentRole === Roles.admin) {
			if (
				this.selectedValues.plant.plantId === 0 ||
				this.selectedValues.unit.unitId === 0
			) {
				return false
			} else if (
				this.selectedValues.plant.isDeleted ||
				this.selectedValues.unit.isDeleted
			) {
				return false
			} else {
				return true
			}
		}
		return true
	}

	handleDeactivate() {
		this.dataPointService.deactivateDataPoint(this.selectedDp)
			.subscribe({
				next: (response) => {
					this.handleSuccessToast('Deactivate_Datapoint');
					this.loadData(this.selectedValues.unit);
				},
				error: (error) => {
					this.errorService.handleError(error, 'Error deactivating form field')
				},
			})
	}

	handleSuccessToast(state:any) {
        if (state === 'Deactivate_Datapoint'){
            this.toastService.toastText = 'Form Field successfully deactivated!'
        }
		this.toastService.showToast = true;
		setTimeout(() => {
			this.toastService.showToast = false;
		}, 5000);
    }

	goToDynamic() {
		this.router.navigateByUrl("add-subsidiary", { state: this.selectedValues })
	}

	loadData(selected: any) {
		this.selectedValues.unit = selected
		this.persistRefreshState()

		this.dataPointService
		.retrieveDataPointByUnitIdPaginated(this.selectedValues.unit.unitId.toString(), this.currentPage, this.pageSize, "true")
		.subscribe({
			next: (result: any) => {
				this.dataPoints = result.item1
				this.data = result.item1
				this.totalPages = result.item2
				this.updateLoopArray()
			},
			error: (err) => {
				this.errorMessage = this.errorService.handleRetrievalErrors(err)
			},
		})
	}

    onPageChange(pageNumber: any) {
		this.currentPage = pageNumber
		this.persistRefreshState()
		this.loadData(this.selectedValues.unit)
	}

	retrievePlantsByCompanyId(selected: any, initial?: boolean) {
		if (!this.firstRender) {
			this.selectedValues = {
				...this.selectedValues,
				company: selected,
			}

			this.selectedValues.plant = {
				plantId: 0,
				plantName: "",
				isDeleted: false,
			}
			this.selectedValues.unit = {
				unitId: 0,
				unitName: "",
				isDeleted: false,
			}
			this.dataPoints = []
		}
		this.selectedValues.company = selected

		if (!initial) {
			if (this.selectedValues.plant.plantId > 0 || this.plants.length > 0) {
				this.resetPlant = true
				this.resetUnit = true
				this.selectedValues.plant = {
					plantId: 0,
					plantName: "",
					isDeleted: false,
				}
				this.selectedValues.unit = {
					unitId: 0,
					unitName: "",
					isDeleted: false,
				}
				this.plants = []
				this.units = []
				this.dataPoints = []
			}
		}

		this.plantService
			.retrieveCompanyPlants(this.selectedValues.company.companyId.toString())
			.subscribe({
				next: (response) => {
					this.plants = response
				},
				error: (err) => {
					this.errorMessage = this.errorService.handleRetrievalErrors(err)
				},
			})
		this.resetPlant = false
		this.persistRefreshState()
	}

	retrieveUnitsByPlantId(selected: any, initial?: boolean) {
		this.selectedValues.plant = selected

		if (!initial) {
			if (this.selectedValues.unit.unitId > 0 || this.units.length > 0) {
				this.resetUnit = true
				this.selectedValues.unit = {
					unitId: 0,
					unitName: "",
					isDeleted: false,
				}
				this.units = []
				this.dataPoints = []
			}
		}
		this.unitService
			.retrieveUnitPlant(this.selectedValues.plant.plantId.toString())
			.subscribe({
				next: (response) => {
					this.units = response
				},
				error: (err) => {
					this.errorMessage = this.errorService.handleRetrievalErrors(err)
				},
			})
		this.resetUnit = false
		this.persistRefreshState()
	}

	retrieveDataPointsByUnitId(selected: any) {
		this.selectedValues.unit = selected
		this.persistRefreshState()
		this.loadData(selected)
	}

	showDeactivateModal(name: string, dpId: any) {
		this.selectedDp = dpId;
		this.deactivateText.message1 = "You are about to deactivate " + name + " in Smart Forms. Doing this will prevent creation of forms with this form field and remove this form field from existing forms."
		this.showDeactivateMenu = true
	}

	showPlantEmptyState() {
		if (
			this.currentRole === Roles.superAdmin &&
			this.selectedValues.company.companyId > 0 &&
			(this.plants.length === 0 || this.selectedValues.plant.plantId === 0) &&
			this.selectedValues.unit.unitId === 0 &&
			// this.plants.length === 0 &&
			this.dataPoints.length === 0
		) {
			return true
		} else if (
			this.currentRole === Roles.admin &&
			(this.plants.length === 0 || this.selectedValues.plant.plantId === 0) &&
			this.selectedValues.unit.unitId === 0
		) {
			return true
		} else {
			return false
		}
	}

	toggleMenu(plantId: number) {
		this.activeItem = plantId
		this.showMenu = !this.showMenu
	}

	transferData() {
		this.firstRender = true
		this.router.navigateByUrl("settings/form-fields", {
			state: {
				selectedValues: { ...this.selectedValues },
				firstRender: this.firstRender,
			},
		})
	}

	updateLoopArray() {
        this.loopArray = new Array(this.totalPages).fill(0).map((_, index) => index + 1);
    }

	ngOnInit(): void {
		this.currentRole = localStorage.getItem("role")
		const saved = this.refreshState.load<{ selectedValues: any; currentPage: number }>('settings:data-points')
		this.firstRender = history.state.firstRender || Boolean(saved?.selectedValues?.unit?.unitId)
		if (!history.state.firstRender && saved) {
			this.selectedValues = saved.selectedValues
			this.currentPage = Math.max(1, saved.currentPage || 1)
		}
		if (this.firstRender) {
			if (history.state.firstRender) this.selectedValues = { ...history?.state?.selectedValues }
			this.retrievePlantsByCompanyId(this.selectedValues?.company, this.firstRender)
			this.retrieveUnitsByPlantId(this.selectedValues?.plant, this.firstRender)
			this.retrieveDataPointsByUnitId(this.selectedValues?.unit)
			this.firstRender = false
		}

		try {
			const storedAssignment = localStorage.getItem("assignedPlants")
			if (storedAssignment) {
				this.assignedPlants = JSON.parse(storedAssignment)
			} 
			else {
				console.error("No data found in local storage for key 'assignedPlants' ");
			}
		} catch (error) {
			console.error("Error parsing JSON data from local storage:", error);
		}

		if (this.currentRole === Roles.admin) {
			this.assignedPlants.map((assignment: Plant) => this.plants.push(assignment))
		} else {
			this.companyService.retrieveCompanies().subscribe({
				next: (companies) => {
					this.companies = companies
				},
				error: (response) => {
					this.errorMessage = this.errorService.handleRetrievalErrors(response)
				},
			})
		}

	}

	ngOnDestroy(): void {
		this.persistRefreshState()
	}

	private persistRefreshState(): void {
		this.refreshState.save('settings:data-points', {
			selectedValues: this.selectedValues,
			currentPage: this.currentPage,
		})
	}
}
